<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productSatellitesIncluded"
    class="m-edition-product-assets-included"
  >
    <blockquote class="quote quote-products-primary quote-first">
      <p>
        <span v-if="!satelites.length">
          {{ $t(`mEditionProductSatellitesIncluded.quote.${tipo}.firstText`) }}
        </span>
        <span v-if="!sateliteIncluido">
          {{ $t(`mEditionProductSatellitesIncluded.quote.${tipo}.secondText`) }}
        </span>
        <span>
          {{ $t(`mEditionProductSatellitesIncluded.quote.${tipo}.thirdText`) }}
        </span>
        <span>
          {{ $t(`mEditionProductSatellitesIncluded.quote.${tipo}.fourthText`) }}
        </span>
      </p>
    </blockquote>

    <blockquote
      v-if="!habilitado"
      class="quote quote-danger-primary"
    >
      <p>{{ $t('mEditionProductSatellitesIncluded.notAllowed') }}</p>
    </blockquote>

    <!--
      Se avisa ACA y no solo al confirmar: si el producto tiene planes que este tipo no admite (para
      un Droop, de contado o cuotas), ninguna tarjeta se va a poder incluir, y descubrirlo recien
      despues de elegir una es hacer trabajo al pedo. El modal lo repite con el detalle de los planes
      cuando igual se hace clic.
    -->
    <blockquote
      v-if="habilitado && planesIncompatibles.length"
      class="quote quote-danger-primary"
    >
      <p>{{ $t(`mEditionProductSatellitesIncluded.incompatiblePlans.${tipo}`) }}</p>
    </blockquote>

    <blockquote
      v-if="habilitado && avisoConProyectos"
      class="quote quote-danger-primary"
    >
      <p>{{ $t(`mEditionProductSatellitesIncluded.withAssets.${tipo}`) }}</p>
    </blockquote>

    <!--
      La venta de este satelite todavia no esta abierta (satelites/validacion: a_la_venta). No es algo
      que se arregle en el producto —no hay ningun plan que dar de baja—, asi que abajo directamente no
      se ofrece ninguna tarjeta para incluir. Lo que YA esta incluido se sigue viendo y se puede
      quitar, igual que lo permite el backend: es la unica forma de deshacer un alta anterior.
    -->
    <blockquote
      v-if="habilitado && !aLaVenta"
      class="quote quote-danger-primary"
    >
      <p>{{ $t(`mEditionProductSatellitesIncluded.notForSale.${tipo}`) }}</p>
    </blockquote>

    <!-- No hay "Incluir Todos / Quitar Todos": el producto guarda un solo satelite por tipo -->
    <div class="display-flex-row-center flex-end">
      <AtomInputPrimary
        v-model="search"
        :placeholder="$t('mEditionProductSatellitesIncluded.search')"
        name="search"
        type="text"
      />
    </div>

    <div class="m-edition-academy-users-profile-assets margin-bottom-xxlarge">
      <a
        v-for="satelite in searchedsIncluidos"
        :key="satelite.id"
        class="m-edition-product-assets-included-proyect"
        href="#"
        @click.prevent="openModal('remove', satelite)"
      >
        <div class="action action-remove">
          {{ $t('mEditionProductSatellitesIncluded.actions.remove') }}
        </div>
        <MoleculeEditionProductSatellitesIncludedCard
          :satelite="satelite"
          :tipo="tipo"
          :is-included="true"
          :is-request-loading="requests.itemLoading === satelite.id"
        />
      </a>

      <template v-if="aLaVenta">
        <a
          v-for="satelite in searchedsNoIncluidos"
          :key="satelite.id"
          class="m-edition-product-assets-included-proyect"
          href="#"
          @click.prevent="openModal('add', satelite)"
        >
          <div class="action action-add">
            {{ $t('mEditionProductSatellitesIncluded.actions.add') }}
          </div>
          <MoleculeEditionProductSatellitesIncludedCard
            class="not-included"
            :satelite="satelite"
            :tipo="tipo"
            :is-included="false"
            :is-request-loading="requests.itemLoading === satelite.id"
          />
        </a>
      </template>
    </div>
  </div>
</template>

<script>
/*
 | El listado de satelites vendibles de cada tipo, por la clave con la que el API nombra al tipo.
 |
 | Es un mapa y no un ternario "juedroop o evaluacion": con un tipo nuevo, un ternario no falla, se
 | equivoca en silencio y lista los satelites de otro. Un tipo nuevo se suma con una linea aca y sus
 | textos en m-edition-product-satellites-included.js.
 */
const ENDPOINTS_LISTADO = {
  juedroop: 'readSatelitesJuedroop',
  evaluacion: 'readSatelitesEvaluacion',
  ruleta: 'readSatelitesRuleta',
  ia_mensual: 'readSatelitesIaMensual',
  ia_creditos: 'readSatelitesIaCreditos'
}

export default {
  name: 'MoleculeEditionProductSatellitesIncludedList',

  components: {
    MoleculeEditionProductSatellitesIncludedCard: () =>
      import('@/components/molecules/MoleculeEditionProductSatellitesIncludedCard')
  },

  props: {
    // El producto, para los avisos que dependen de el y no de sus planes. Lo pasa el contenedor que
    // lo necesita; sin el, esos avisos no se muestran
    element: {
      type: Object,
      default: null
    },

    // La clave del satelite en el API (una de ENDPOINTS_LISTADO): con ella se lee el GET, se arma el
    // PUT, se pide la validacion y se buscan los textos
    tipo: {
      type: String,
      default: 'juedroop'
    }
  },

  data () {
    return {
      habilitado: true,
      /*
       | Planes que hoy tiene el producto y que el satelite de este tipo no admite, tal como los nombra
       | el backend.
       |
       | Mientras no este vacio no se puede incluir ningun satelite de este tipo: un Droop se vende solo
       | por suscripcion mensual o anual, igual que un producto Vidroop. El listado lo usa para avisarlo
       | ANTES de abrir la confirmacion; quien de verdad lo impide es UpdateProductoSatelitesService.
       */
      planesIncompatibles: [],
      // Lo que contesta satelites/validacion: si hoy se puede incluir un Droop en este producto
      puedeIncluir: true,
      /*
       | Si la venta de ESTE tipo de satelite esta abierta. Un satelite puede estar terminado del lado
       | comercial y no tener producto detras todavia: hasta que lo tenga, el backend no deja incluirlo
       | en un producto y esta pantalla no lo ofrece. Arranca en true y el backend lo corrige: un core
       | anterior a esta clave no la manda, y ahi se comporta como siempre.
       */
      aLaVenta: true,
      requests: {
        itemLoading: ''
      },
      satelites: [],
      sateliteIncluido: null,
      search: '',
      showLoadingState: true
    }
  },

  computed: {
    /*
     | Un paquete de creditos se vende solo, sin cursos ni mapas. El backend no lo impide, asi que se
     | avisa aca. Lo muestran los tipos que tienen texto en withAssets, no un if por tipo.
     */
    avisoConProyectos () {
      const clave = `mEditionProductSatellitesIncluded.withAssets.${this.tipo}`

      return !!(this.element && this.element.proyectos && this.element.proyectos.length) &&
        this.$te(clave)
    },

    incluidos () {
      if (!this.sateliteIncluido) {
        return []
      }

      // El incluido puede estar desactivado o eliminado y por eso no venir en el listado de
      // vendibles: igual hay que mostrarlo, porque el producto lo tiene
      const enListado = this.satelites.find(s => s.id === this.sateliteIncluido.id)

      return [enListado || this.sateliteIncluido]
    },

    noIncluidos () {
      return this.satelites.filter(satelite =>
        !this.sateliteIncluido || satelite.id !== this.sateliteIncluido.id
      )
    },

    searchedsIncluidos () {
      return this.filtrar(this.incluidos)
    },

    searchedsNoIncluidos () {
      return this.filtrar(this.noIncluidos)
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    // El modal confirma y avisa por acá
    updatedData () {
      // Se lee element de forma sincronica: closeModal() lo pone en null
      if (this.$modal.methodToRun === 'updateProductoSatelites' && this.$modal.element) {
        this.updateProductoSatelites(this.$modal.element.action, this.$modal.element.satelite)
      }
    }
  },

  created () {
    this.readTodo()
  },

  methods: {
    /*
     | El mensaje con el que el backend rechazo, si lo mando.
     |
     | Viaja como { error: { code, message } } y llega con status 500, porque las rutas de
     | producto/satelites no estan entre los prefijos que el Handler del core mapea a 4xx. Por eso se
     | lee el CUERPO y no el status. Sin mensaje reconocible se cae a un texto propio.
     */
    mensajeDelBackend (error) {
      const data = error && error.response ? error.response.data : null
      const mensaje = data && data.error ? data.error.message : null

      return typeof mensaje === 'string' && mensaje.trim()
        ? mensaje
        : this.$t('mEditionProductSatellitesIncluded.modal.failed.fallback')
    },

    endpointListado () {
      return ENDPOINTS_LISTADO[this.tipo]
    },

    filtrar (lista) {
      if (!this.search) {
        return lista
      }

      const termino = this.search.toLowerCase()

      return lista.filter(satelite =>
        `${satelite.titulo} ${satelite.descripcion || ''}`.toLowerCase().includes(termino)
      )
    },

    abrirModal (action, satelite, motivo) {
      this.$modal.showModal('MoleculeEditionProductSatellitesIncludedModal', {
        action: action,
        satelite: satelite,
        sateliteIncluido: this.sateliteIncluido,
        tipo: this.tipo,
        // Con esto puesto el modal no confirma nada: muestra por que el backend rechazo
        motivo: motivo || '',
        /*
         | Quien decide si se puede es el backend (satelites/validacion), no el front: aca solo se
         | traslada su veredicto. Bloqueado, el modal explica por que en vez de ofrecer un confirmar
         | que el PUT va a rechazar.
         */
        bloqueado: action === 'add' && !this.puedeIncluir,
        planesIncompatibles: this.planesIncompatibles
      })
    },

    /*
     | Incluir un Droop son DOS pasos contra el API, y en ese orden: primero se pregunta si el
     | producto esta en condiciones (satelites/validacion) y solo si pasa se abre la confirmacion que
     | termina en el alta (PUT satelites).
     |
     | La validacion se rehace en el clic y no se confia en la que trajo readTodo(): entre que se
     | abrio la pantalla y que se elige una tarjeta pueden haber pasado minutos, y los planes se
     | editan en otra pestaña de este mismo producto.
     |
     | Quitar no valida nada: sacar un Droop tiene que poder hacerse siempre, y es justamente como se
     | sale de un producto que quedo con las dos cosas.
     */
    openModal (action, satelite) {
      if (!this.habilitado || this.requests.itemLoading) {
        return
      }

      // Con la venta cerrada solo se puede QUITAR, que es lo mismo que deja hacer el backend
      if (!this.aLaVenta && action === 'add') {
        return
      }

      if (action !== 'add') {
        this.abrirModal(action, satelite)
        return
      }

      this.requests.itemLoading = satelite.id

      this.readValidacion(this.$route.params.id)
        .then(response => {
          // Se guarda para que el aviso de la cabecera quede al dia sin recargar la pantalla
          this.planesIncompatibles = this.planesIncompatiblesDe(response.data)
          this.puedeIncluir = response.data.puede_incluir

          this.abrirModal(action, satelite)
        })
        .catch(() => {
          this.$alerts.pushAlert('mEditionProductSatellitesIncluded', 'readSatelites', 'error', 'a-alert-danger')
        })
        .finally(() => {
          this.requests.itemLoading = ''
        })
    },

    /*
     | Los planes del producto que no admite el satelite de este tipo, tal como los nombra el backend.
     |
     | Con ?tipo= el backend los devuelve en planes_incompatibles; planes_no_suscripcion es la misma
     | lista, que se sigue mandando por compatibilidad y es la unica que conoce un backend anterior.
     */
    planesIncompatiblesDe (validacion) {
      return validacion.planes_incompatibles || validacion.planes_no_suscripcion || []
    },

    /*
     | La validacion se pide para el tipo de esta pestaña (?tipo=): cada satelite tiene su regla de
     | cobro y los planes que la rompen no son los mismos para todos.
     */
    readValidacion (uuidProducto) {
      return this.$services.read('satelite', 'readProductoSatelitesValidacion', {}, [uuidProducto], { tipo: this.tipo })
    },

    readTodo () {
      const uuidProducto = this.$route.params.id

      /*
       | Tres lecturas, una por pregunta: que Droops hay para vender, cual incluye este producto, y
       | si el producto esta en condiciones de incluir alguno. La ultima es un endpoint propio
       | (satelites/validacion) porque es otra pregunta que las anteriores.
       */
      Promise.all([
        this.$services.read('satelite', this.endpointListado(), {}, [], { solo_vendibles: 1 }),
        this.$services.read('satelite', 'readProductoSatelites', {}, [uuidProducto]),
        this.readValidacion(uuidProducto)
      ])
        .then(([listado, delProducto, validacion]) => {
          this.satelites = listado.data
          this.sateliteIncluido = delProducto.data[this.tipo]
          this.habilitado = validacion.data.habilitado
          this.planesIncompatibles = this.planesIncompatiblesDe(validacion.data)
          this.puedeIncluir = validacion.data.puede_incluir
          this.aLaVenta = validacion.data.a_la_venta !== false
        })
        .catch(() => {
          this.$alerts.pushAlert('mEditionProductSatellitesIncluded', 'readSatelites', 'error', 'a-alert-danger')
        })
        .finally(() => {
          this.showLoadingState = false
        })
    },

    updateProductoSatelites (action, satelite) {
      if (this.requests.itemLoading) {
        return
      }

      this.requests.itemLoading = satelite.id

      /*
       | Se manda SOLO el tipo de esta pestaña: en el backend, una clave ausente no se toca (null la
       | quita, un uuid la incluye). Antes el endpoint era un SET y habia que releer el otro tipo para
       | volver a mandarlo tal cual; con mas tipos, cada pestaña tendria que conocer a todos los demas,
       | y una que se olvidara de uno lo borraria sin avisar.
       */
      const data = {
        satelites: {
          [this.tipo]: action === 'add' ? satelite.id : null
        }
      }

      this.$services.update('satelite', 'updateProductoSatelites', data, [this.$route.params.id])
        .then(() => {
          this.sateliteIncluido = action === 'add' ? satelite : null
          this.$modal.closeModal()

          // Refresca el producto en la vista: "Precios y Planes" lee element.satelite_* para saber
          // si puede habilitar la venta sin proyectos
          this.$modal.updateData('readElement')
          this.$alerts.pushAlert('mEditionProductSatellitesIncluded', 'updateProductoSatelites', 'success', 'a-alert-success')
        })
        .catch(error => {
          /*
           | El backend explica POR QUE rechazo —"el producto quedaria sin proyectos y sin Droops",
           | "tiene planes de contado o de cuotas"— y ese mensaje es exactamente lo que el usuario
           | necesita para saber que corregir. Antes se perdia: el catch cerraba el modal y mostraba
           | una alerta generica que decia "no se pudo actualizar" y nada mas.
           |
           | Se cierra y se vuelve a abrir en el tick siguiente, y no se reusa el modal abierto,
           | porque showModal() no re-monta el componente si el modalBody es el mismo: sin pasar por
           | null, created() no vuelve a correr y el modal seguiria mostrando la confirmacion.
           */
          this.$modal.closeModal()
          this.$nextTick(() => {
            this.abrirModal(action, satelite, this.mensajeDelBackend(error))
          })
        })
        .finally(() => {
          this.requests.itemLoading = ''
        })
    }
  }
}
</script>
